import {Video} from './Video';

export default {
    title: 'Elements/Video',
    component: Video,
    parameters: {
        layout: 'centered',
    },
    tags: ['autodocs'],
    argTypes: {

    },
}

export const Default= {
    args: {
        videoUrl: 'https://cdn.shopify.com/videos/c/vp/d7892d40986a441babd74bf035773611/d7892d40986a441babd74bf035773611.HD-720p-1.6Mbps-21849354.mp4',
        type: 'video/mp4'
    },
};




